import { useEffect, useState } from 'react';

/** Milliseconds left until `target` (epoch ms), re-rendering once a second; 0 once it passes. */
export const useCountdown = (target: number | null) => {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (target == null) return;
		setNow(Date.now());
		const id = setInterval(() => setNow(Date.now()), 1000);
		return () => clearInterval(id);
	}, [target]);

	return target == null ? 0 : Math.max(0, target - now);
};

const pad = (n: number) => String(n).padStart(2, '0');

export const splitCountdown = (ms: number) => {
	const total = Math.floor(ms / 1000);
	return {
		days: pad(Math.floor(total / 86400)),
		hours: pad(Math.floor((total % 86400) / 3600)),
		minutes: pad(Math.floor((total % 3600) / 60)),
		seconds: pad(total % 60),
	};
};

/** "12:45" under an hour, "01:58:20" under a day, "2d 03:10:00" beyond - the registered-row timer. */
export const formatCountdown = (ms: number) => {
	const { days, hours, minutes, seconds } = splitCountdown(ms);
	if (days !== '00') return `${Number(days)}d ${hours}:${minutes}:${seconds}`;
	if (hours !== '00') return `${hours}:${minutes}:${seconds}`;
	return `${minutes}:${seconds}`;
};
